export function useTrustSummariesAnnouncement() {
  return {
    heading: 'Updated document summaries',
    imageUrl: 'trust-summary-announcement.png',
    imageAlt:
      'A dense summary transforms into a structured summary with clear sections, bullet points, and highlighted callouts.',
    bodyText:
      'We’re updating document summaries to a more capable model family, designed to produce richer, more robust summaries and capture more nuanced and detailed scenarios than the previous model family.',
    actionButtons: null,
  };
}
